import React, { useEffect, useState } from "react";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fromStore, modalsSelector } from "../../selectors";
import { isEmpty } from "lodash";
import { addAutoConsumption, fetchAutoConsumption, fetchAutoConsumptions, fetchGoods, fetchRawsList, setActiveModalAction, updateAutoConsumption } from "../../action";
import { parseNumToFixed } from "../../utils/common";
import { useOnClickOutside } from "../../hooks";
import ErrorContainer from "../../components/utils/ErrorContainer";
import cn from 'classnames';
import Select from 'react-select';
import Switch from "../../components/utils/Switch";

const colourStyles = {
    control: (styles) => ({ ...styles, border: "1px solid #e2e5ec" }),
};

const optionsTypeProduct = [
    { label: 'Товар', value: 'good' },
    { label: 'Полуфабрикат', value: 'semi' },
    { label: 'Сырье', value: 'raw' },
];

export default function AutoConsumptionModal() {
    const ref = useRef();
    const modalRef = useRef(null);
    const dispatch = useDispatch();
    const id = useSelector(modalsSelector).autoConsumption;
    const loading = useSelector((state) => state.loaders.addAutoConsumption);
    const loadingUpdate = useSelector((state) => state.loaders.editAutoConsumption);
    const edit = useSelector((state) => state.automaticConsumption.edit);
    const goods = useSelector(state => state.good.list);
    const raws = useSelector(fromStore.rawListSelector);

    const loader = loading || loadingUpdate;
    const isEditMode = id && id !== 'new';

    const initData = (isEditMode && !isEmpty(edit)) ? {
        typeProduct: edit.typeProduct,
        countProduct: edit.countProduct,
        idProduct: edit.idProduct,
        type: edit.type,
        count: edit.count,
        active: edit.active
    } : {
        typeProduct: null,
        countProduct: 0,
        idProduct: null,
        type: 'unit',
        count: 1,
        active: true
    };

    const [data, setData] = useState(initData);

    useEffect(() => {
        const getData = async () => {
            const res = await dispatch(fetchAutoConsumption(id));
            setData(res);
        }
        if (isEditMode && isEmpty(edit)) getData()
        if (isEmpty(goods)) dispatch(fetchGoods());
        if (isEmpty(raws)) dispatch(fetchRawsList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onChangeNumberInput = (field, fix = 2) => (e) => {
    const updated = {...data};
        if(e.target.value.match(/^([0-9]{1,})?(\.)?([0-9]{1,})?$/)) {
            updated[field] = parseNumToFixed(e.target.value, fix);
            setData(updated);
        }
    };

    const onChangeSwitch = (field) => (e) => {
        const updated = {...data};
        updated[field] = e;
        setData(updated);
    }

    const onChangeSelect = (field) => (e) => {
        const updated = {...data};
        updated[field] = e.value;
        setData(updated);
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!isEditMode) {
            const result = await dispatch(addAutoConsumption(data));
            if (result) onClose();
        } else {
            const result = await dispatch(updateAutoConsumption(id, data));
            if (result) onClose();
        }
    };

    const isValid = () => {
        const { typeProduct, countProduct, idProduct, type, count } = data;
        if (!typeProduct || !type || !countProduct || !count || !idProduct) return false;
        return true;
    }

    const onClose = () => {
        if (!loader) {
            dispatch(setActiveModalAction({ field: 'autoConsumption', value: null }));
            dispatch(fetchAutoConsumptions())
        }
    }

    useOnClickOutside(ref, onClose);

    const getArrProducts = () => {
        if (!data || !data.typeProduct) return [];
        const arr = data.typeProduct === 'good' ? goods : raws;
        return arr.map((item) => ({ label: item.name, value: item.id }));
    }

    const renderBody = () => {
        const productOptions = getArrProducts();

        return (
          <>
          <div className='row'>
            <div className='col-6' style={window.innerWidth <= 510 ? {flex: '0 0 50%', maxWidth: '50%'} : {}}>
              <div className="form-group">
                <label className="form-control-label">Тип продукта *</label>
                <Select
                    value={data.typeProduct ? optionsTypeProduct.find((option) => option.value === data.typeProduct) : null}
                    options={optionsTypeProduct}
                    onChange={onChangeSelect('typeProduct')}
                    isClearable={false}
                    placeholder="Тип продукта..."
                    disabled={loader}
                    styles={colourStyles}
                  />
              </div>
            </div>
              <div className='col-6' style={window.innerWidth <= 510 ? {flex: '0 0 50%', maxWidth: '50%'} : {}}>
                <div className="form-group">
                  <label className="form-control-label">Продукт *</label>
                  <Select
                    isDisabled={!data || !data.typeProduct}
                    value={data.idProduct ? productOptions.find((item) => item.value === data.idProduct) : null}
                    options={productOptions}
                    onChange={onChangeSelect('idProduct')}
                    isClearable={false}
                    placeholder="Выберите продукт..."
                    disabled={loader}
                    styles={colourStyles}
                  />
                </div>
              </div>
          </div>
          <div className='row'>
            <div className='col-6' style={window.innerWidth <= 510 ? {flex: '0 0 50%', maxWidth: '50%'} : {}}>
              <div className="form-group">
                <label className="form-control-label">Кол-во продукта *</label>
                <input
                    type="number"
                    className="form-control"
                    min="0"
                    step="0.0001"
                    value={parseNumToFixed(data.countProduct, 3) || 0}
                    onFocus={(e) => e.target.select()}
                    onChange={onChangeNumberInput('countProduct', 3)}
                    required
                />
              </div>
            </div>
            
          </div>
          <div className="row">
            <div className='col-6' style={window.innerWidth <= 510 ? {flex: '0 0 50%', maxWidth: '50%'} : {}}>
                <div className="form-group">
                  <label className="form-control-label">От приборов</label>
                    <div className="col-2">
                        <Switch onChange={() => true} checked={true} />
                    </div>
                </div>
            </div>
            <div className='col-6' style={window.innerWidth <= 510 ? {flex: '0 0 50%', maxWidth: '50%'} : {}}>
                <div className="form-group">
                  <label className="form-control-label">Включено</label>
                    <div className="col-2">
                        <Switch onChange={onChangeSwitch('active')} checked={data.active} />
                    </div>
                </div>
            </div>
          </div>
          </>
        );
    }

    return (
        <form onSubmit={onSubmit}>
          <div  className="modal fade show" style={{ display: 'block' }}>
            <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '90%', alignItems: 'center', justifyContent: 'center' }}>
              <div ref={ref} className="modal-content" style={{ height: '80%' }}>
                <div className="modal-header">
                  <h5 className="modal-title"> {isEditMode ? `Редактирование авторасхода ${id}` : 'Создание авторасхода'} </h5>
                  <button onClick={onClose} type="button" className="close">
                  </button>
                </div>
                <div ref={modalRef} className="modal-body">
                    {renderBody()}
                    <ErrorContainer field="addAutoConsumption" hasCloseButton={true}/>
                </div>
    
                <div className="modal-footer">
                  <button disabled={loader} type="button" className="btn btn-secondary" onClick={onClose}>Отмена</button>
                  <button
                    type="submit"
                    disabled={!isValid() || loader}
                    className={cn({ 'btn btn-primary  kt-spinner--right kt-spinner--sm kt-spinner--light': true, 'kt-spinner': loader })}>
                    Сохранить
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      );
}